<div class="py-3.5 pl-4 flex items-center md:pt-10 md:pb-14.5 md:mx-auto md:max-w-[1170px] md:w-[90%] overflow-hidden">
  <div class="live w-6 min-w-6 h-[72px] bg-[#23252E] relative rounded-[8px] mr-1.5 md:w-12 md:h-24.5 md:min-w-12">
    <div
      class="flex items-center absolute top-1/2 left-1/2 -rotate-90 -translate-x-1/2 -translate-y-1/2 text-sm font-bold text-[#a3a3a7] md:text-xl md:leading-[23px]">
      Live <span class="block w-[5px] h-[5px] rounded-full bg-[#00FF00] ml-1 md:w-2.5 md:h-2.5"></span>
    </div>
  </div>

  <div class="flex items-center gap-2">
    @for (item of gifts().list; track item._eventId) {
      <div
        [class]="
          `text-center bg-[#191B21]/20 border h-[72px] w-[82px] pt-1 pb-1 flex items-center overflow-hidden relative justify-between flex-col text-xs rounded-[10px]  ${item?.border_color ? `border-[${item.border_color}]` : 'border-[#53D4FF]'}`
        "
        [style.borderColor]="item?.border_color ? item?.border_color : '#53D4FF'">
<!--        <div class="absolute bottom-0 left-0 right-0 h-24 bg-[radial-gradient(ellipse_120%_100%_at_bottom,#3b82f6_0%,#1e3a8a_40%,transparent_70%)]"></div>-->


      <app-gift-gradient [color]="item?.border_color ? item.border_color : '#53D4FF'" />


        <img
            [src]="(resolveImageSrc(item.image_url) | cachedImage | async) || resolveImageSrc(item.image_url)"
            width="65"
            height="65"
            [id]="item.id"
            alt="{{item?.title}}"
            loading="lazy"
            class="w-7 aspect-square object-contain flex object-center mb-[1.5px]" />

          <p class="text-[8px] font-medium leading-[7px] mb-[2px]">
            {{item?.title}}
          </p>
        <div class="w-full flex justify-center">
          <p class="h-[12px] bg-[#2D303C]/45 rounded-[6px] flex items-center justify-center gap-[1px] text-[10px] px-1 min-w-[23px]">
            {{item?.price_in_stars}}
            <svg class="min-w-2 h-auto flex " width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4.54271 3.56486L4.7935 5.0025C4.83314 5.22916 4.58416 5.4006 4.37241 5.29302L3.02837 4.60929C2.94427 4.56644 2.84366 4.56615 2.75896 4.60814L1.4086 5.28065C1.19596 5.3865 0.948475 5.21306 0.990223 4.98668L1.12598 4.24859C1.17884 3.96066 1.36956 3.71329 1.64137 3.57982L3.03948 2.89351C3.12178 2.85324 3.08303 2.73358 2.99112 2.74508L1.33202 2.95334C1.03467 2.99073 0.736131 2.89495 0.522285 2.6936L0.0867844 2.2837C-0.0841122 2.12263 0.0116982 1.84361 0.249271 1.81168L1.7564 1.60832C1.85071 1.59566 1.93241 1.53929 1.97506 1.4576L2.65444 0.153424C2.76166 -0.0522399 3.06831 -0.0508017 3.17343 0.155726L3.8411 1.46565C3.88285 1.54763 3.96424 1.60458 4.05825 1.6181L5.56328 1.83383C5.80055 1.86777 5.89396 2.14765 5.72156 2.30729L4.62711 3.32008C4.55863 3.38336 4.52709 3.47512 4.54271 3.56515V3.56486Z" fill="white"/>
            </svg>
          </p>
        </div>

      </div>
    }
  </div>
</div>
